import React, { useCallback } from 'react'

export function GuidePage({ title, subtitle, html, onMdLink }) {
  // Intercept clicks on `<a href="...md">` so they navigate within the docs
  // shell instead of letting the browser follow a relative URL into the SPA
  // shell (which 404s the .md file).
  const handleClick = useCallback((event) => {
    const anchor = event.target.closest('a')
    if (!anchor) return
    const href = anchor.getAttribute('href')
    if (!href) return
    // Strip any URL fragment so links like ./guide-reports.md#goals also resolve.
    const path = href.split('#')[0]
    if (!path.endsWith('.md')) return
    event.preventDefault()
    if (!onMdLink) return
    const match = path.match(/([^/]+)\.md$/)
    if (!match) return
    onMdLink(match[1])
  }, [onMdLink])

  return (
    <div>
      <h2 style={styles.heading}>{title}</h2>
      {subtitle && <p style={styles.subtitle}>{subtitle}</p>}
      <div
        className="guide-body"
        style={styles.body}
        onClick={handleClick}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </div>
  )
}

const styles = {
  heading: { fontSize: '18px', fontWeight: 700, margin: '0 0 4px' },
  subtitle: { fontSize: '13px', color: 'var(--text-secondary)', margin: '0 0 24px' },
  body: { fontSize: '13px', color: 'var(--text-secondary)', lineHeight: 1.6 },
}
